/* eslint-disable camelcase */
import * as Yup from 'yup';
import { santiagoAndMobileAreaCodes, regionNumsAreaCodes, MailRegex } from '../../../../../../utils/helpers';

// Mismas reglas que ContactForm/DataForm (validationSchema.ts), pero sin modificar un objeto
// compartido: allá se borran del módulo las llaves que no vienen en el formulario.
const phoneRule = Yup.object().shape({
  value: Yup.string()
    .test('num-required', 'Ingresa un número válido de 9 dígitos', (num?: string) => {
      const clean = (num || '').replace(' ', '');
      if (clean.length >= 3) return Yup.string().min(12).max(12).isValidSync(clean);
      return true;
    })
    .test('num-area-invalid', 'Ingresa un celular o un código de área de Chile', (num?: string) => {
      const clean = (num || '').replace(' ', '');
      if (clean.length === 12) {
        return santiagoAndMobileAreaCodes.includes(clean[3])
          || regionNumsAreaCodes.includes(clean.slice(3, 5));
      }
      return true;
    }),
});

const emailRule = Yup.object().shape({
  ok: Yup.bool(),
  value: Yup.string()
    .required('Ingresa un correo válido')
    .matches(MailRegex, 'Ingresa un correo válido')
    .test('email-invalid', 'Ingresa un correo válido', (email, context) => {
      if (!email) return false;
      // Un correo con asteriscos solo vale si es el que ya teníamos (sin modificar).
      return !(!context.parent.ok && email.includes('*'));
    }),
});

const required = 'Completa este campo';
const contactRules: Record<string, Yup.AnySchema> = { phone: phoneRule, email: emailRule };
const dataRules: Record<string, Yup.AnySchema> = {
  age: Yup.object().shape({
    value: Yup.number().typeError(required).required(required)
      .min(1, 'Revisa tu edad')
      .max(99, 'Revisa tu edad'),
  }),
  sex: Yup.object().shape({ value: Yup.string().required('Elige una opción') }),
  type_of_contract: Yup.object().shape({ value: Yup.string().required('Elige una opción') }),
  emp_length: Yup.object().shape({ value: Yup.string().required(required) }),
  licenses: Yup.object().shape({ value: Yup.string().required(required) }),
  brute_salary: Yup.object().shape({
    value: Yup.number().typeError(required).required(required)
      .min(90_000, 'Debe ser de al menos $90.000')
      .max(10_000_000, 'Revisa el monto: parece que sobra un dígito'),
  }),
  net_salary: Yup.object().shape({
    value: Yup.number().typeError(required).required(required)
      .min(90_000, 'Debe ser de al menos $90.000')
      .max(10_000_000, 'Revisa el monto: parece que sobra un dígito'),
  }),
};

const pick = (rules: Record<string, Yup.AnySchema>, keys: string[]) => Object.fromEntries(
  keys.filter((key) => rules[key]).map((key) => [key, rules[key]]),
);

export default function fillFormValidation(contactKeys: string[], dataKeys: string[]) {
  return Yup.object().shape({
    contactForm: Yup.object().shape(pick(contactRules, contactKeys)),
    dataForm: Yup.object().shape(pick(dataRules, dataKeys)),
  });
}
